<template>
  <div>
    <p class="text-blue-500 text-2xl lg:text-4xl text-center font-bold">Our History</p>
    <u-animate-container class="timeline">
      <u-animate
          v-for="(milestone, index) in milestones"
          :key="milestone.id"
          :name="index % 2 != 1 ? 'fadeInRight' : 'fadeInLeft'"
          delay="1s"
          duration="1s"
          :iteration="1"
          :offset="20"
          animateClass="animated"
          :begin="false"
        >
          <div class="cont" :class="index % 2 != 1 ? 'left' : 'right'" >
            <div class="date">{{milestone.year}}</div>
            <i class="icon fa fa-home"></i>
            <div class="content">
              <p>
                {{milestone.content}}
              </p>
            </div>
          </div>
        </u-animate>
    </u-animate-container>
    <div class="mt-6 py-8 lg:py-12 bg-gray-100">
      <p class="text-center font-bold text-blue-500 text-2xl lg:text-4xl">Awards & Recognition </p>
      <ul class="mt-12 px-6 flex awardlist lg:gap-10">
        <li v-for="award in awards" :key="award.id" class="flex flex-col justify-between">
          <p class="font-semibold text-lg">{{award.content}}</p>
          <p class="text-lg mt-8 font-light">{{award.year}}</p>
        </li>
      </ul>
    </div>
  </div>


</template>

<script>
import "animate.css"
// import axios from 'axios'
// import baseURL from '@/main'

export default {
  props: ['awards', 'milestones'],
  data(){
    return {
      
    }
  },
  mounted() {
    // this.$store.commit('startLoading')
    // axios.get(`${baseURL}/api/history`)
    // .then(res=>{
    //   this.milestones = res.data.result
    //   this.$store.commit('stopLoading')
    // })
    // .catch(err=>{
    //   this.$store.commit('stopLoading')
    //   console.log(err)
    // })
    // axios.get(`${baseURL}/api/awards`)
    // .then(res=>{
    //   this.awards = res.data.result
    //   // console.log(this.awards)
    //   this.$store.commit('stopLoading')
    // })
    // .catch(err=>{
    //   this.$store.commit('stopLoading')
    //   console.log(err)
    // })
  }

}
</script>

<style scoped>


ul li p{
  color: #062648
}
.awardlist{
  flex-wrap: wrap;
}
ul li{
  background: #fff;
  padding: 40px 20px 20px 20px;
  width: 45%
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

.timeline {
  position: relative;
  width: 100%;
  max-width: 1140px;
  margin: 50px auto;
  padding: 15px 0;
}

.timeline::after {
  content: '';
  position: absolute;
  width: 2px;
  background: #062648;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -1px;
}
.animated{
  visibility: hidden;
}
.cont {
  padding: 15px 30px;
  position: relative;
  background: inherit;
  width: 50%;
  /* visibility: hidden; */
}

.cont.left {
  left: 0;
}

.cont.right {
  left: 50%;
}

.cont::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  top: calc(50% - 8px);
  right: -8px;
  background: #062648;
  border: 2px solid #062648;
  border-radius: 16px;
  z-index: 1;
}

.cont.right::after {
  left: -8px;
}

.cont::before {
  content: '';
  position: absolute;
  width: 50px;
  height: 2px;
  top: calc(50% - 1px);
  right: 8px;
  background: #062648;
  z-index: 1;
}

.cont.right::before {
  left: 8px;
}

.cont .date {
  position: absolute;
  display: inline-block;
  top: calc(50% - 8px);
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #062648;
  text-transform: uppercase;
  letter-spacing: 1px;
  z-index: 1;
}

.cont.left .date {
  right: -75px;
}

.cont.right .date {
  left: -75px;
}

.cont .icon {
  position: absolute;
  display: inline-block;
  width: 40px;
  height: 40px;
  padding: 9px 0;
  top: calc(50% - 20px);
  background: rgba(219, 234, 254, 1);
  border: 2px solid #062648;
  border-radius: 40px;
  text-align: center;
  font-size: 18px;
  color: #062648;
  z-index: 1;
}

.cont.left .icon {
  right: 56px;
}

.cont.right .icon {
  left: 56px;
}

.cont .content {
  padding: 30px 90px 30px 30px;
  background: rgba(219, 234, 254, 1);
  position: relative;
  border-radius: 0 500px 500px 0;
}

.cont.right .content {
  padding: 30px 30px 30px 90px;
  border-radius: 500px 0 0 500px;
}


.cont .content p {
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  color: #062648;
}

@media (max-width: 767.98px) {
  .timeline::after {
    left: 90px;
  }

  .cont {
    width: 100%;
    padding-left: 120px;
    padding-right: 30px;
  }

  .cont.right {
    left: 0%;
  }

  .cont.left::after,
  .cont.right::after {
    left: 82px;
  }

  .cont.left::before,
  .cont.right::before {
    left: 100px;
    border-color: transparent #006E51 transparent transparent;
  }

  .cont.left .date,
  .cont.right .date {
    right: auto;
    left: 15px;
  }

  .cont.left .icon,
  .cont.right .icon {
    right: auto;
    left: 146px;
  }

  .cont.left .content,
  .cont.right .content {
    padding: 30px 30px 30px 90px;
    border-radius: 500px 0 0 500px;
  }
}
@media only screen and (min-width: 1024px){
  .awardlist{
    width: 75%;
    margin-left: auto;
    margin-right: auto
  }
  .awardlist li{
    width: 30%;
  }
}

</style>